import { IDeductionChip, ValidityKey, VALIDITY_ICONS } from "./IDeductionChips";
import { cn } from "@/infrastructure/adapters/classnames";
import { getValidityChipClassName } from "./DeductionChipUtils";
import { DeductionChip } from "./DeductionChip";

interface ValidityChipProps extends IDeductionChip {
  validityKey: string;
  validityName: string;
}

export const ValidityChip = ({ validityKey, validityName, withIcon = false, withBorder = true, withBackground = false, size = "small", shape, style, className }: ValidityChipProps) => {
  if (!validityKey) {
    return null;
  }

  const classNames = cn(getValidityChipClassName(validityKey as ValidityKey, withBorder, withBackground), "validity-chip", className);
  const icon = VALIDITY_ICONS[validityKey as ValidityKey];

  return (
    <DeductionChip
      icon={withIcon && icon ? icon : undefined}
      label={validityName}
      size={size}
      shape={shape}
      style={style}
      className={classNames}
    />
  );
};
